export const TWO_OR_MORE_DECIMAL_PLACES = /\.\d{2,}$/g
export const LESS_THAN_TWO_DECIMAL_PLACES = /\.\d{0,1}$/g

interface FormatNumberOptions {
  style?: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
}

export const formatDecimal = (
  value: number,
  options: FormatNumberOptions = {
    style: 'decimal',
    maximumFractionDigits: 2,
  }
): string => {
  return new Intl.NumberFormat('en-US', options).format(value)
}

export const formatInputToCurrency = (value: string): string => {
  let currency: string

  // Remove any commas from the formatted number
  const numValue = Number.parseFloat(value.replace(/,/g, ''))

  // Check for more than one decimal points
  if (value.search(LESS_THAN_TWO_DECIMAL_PLACES) !== -1) {
    // Do not allow more than one decimal point
    if (value.split('.').length - 1 > 1) {
      currency = formatDecimal(numValue)
    } else {
      // format value to the left of decimal point (eg. 1234.5 => 1,234.5)
      const intValue = Math.trunc(numValue)
      if (intValue) {
        currency = `${formatDecimal(intValue)}.${value.split('.')[1]}`
      } else {
        currency = value
      }
    }
  } else if (value.search(TWO_OR_MORE_DECIMAL_PLACES) !== -1) {
    currency = formatDecimal(numValue, {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  } else {
    currency = formatDecimal(numValue)
  }

  return currency
}
